import cardConstants from '../constants';
import authConstants from '../../auth/constants';

const appendCard = (cards, card) => {
    cards[card.cardData.qrCode] = card;
    cards[card.qrCode] = card; // this may be the virtual card
    card.qrCode = card.cardData.qrCode;

    return cards;
}

const appendPass = (passes, pass) => {
    passes[pass.qrCode] = pass;
    return passes;
}

const initial = {
    cards: {},
    passes: {},
    showJobRoleSelectionPage: false,
    showCardholderPage: false,
    showVisitorPassPage: false,
    cardholderPageContext: '',
    currentQrCode: '',
    currentJobRoleId: ''
};

// state: key/value map of QRcode to CardData
export function cards(state = initial, action) {
    switch (action.type) {
        case authConstants.SIGN_OUT_SUCCESS:
            return {
                ...initial
            };

        case cardConstants.SHOW_JOBROLE_SELECTION_PAGE:
            return {
                ...state,
                showCardholderPage: false,
                showVisitorPassPage: false,
                showJobRoleSelectionPage: true,
                cardholderPageContext: action.context,
                currentQrCode: action.qrCode,
                currentJobRoleId: ''
            };
        case cardConstants.CLOSE_JOBROLE_SELECTION_PAGE:
            return {
                ...state,
                showCardholderPage: false,
                showVisitorPassPage: false,
                showJobRoleSelectionPage: false,
                cardholderPageContext: null,
                currentQrCode: '',
                currentJobRoleId: null
            };
        case cardConstants.HIDE_JOBROLE_SELECTION_PAGE:
            return {
                ...state,
                showCardholderPage: true,
                showVisitorPassPage: false,
                showJobRoleSelectionPage: false,
                currentJobRoleId: action.jobRoleId
            };
        case cardConstants.SHOW_CARDHOLDER_PAGE:
            return {
                ...state,
                showCardholderPage: true,
                showVisitorPassPage: false,
                showJobRoleSelectionPage: false,
                cardholderPageContext: action.context,
                currentQrCode: action.qrCode
            };
        case cardConstants.HIDE_CARDHOLDER_PAGE:
            return {
                ...state,
                cardholderPageContext: '',
                showCardholderPage: false,
                showVisitorPassPage: false,
                showJobRoleSelectionPage: false,
                currentQrCode: null
            };
        case cardConstants.SHOW_VISITOR_PASS_PAGE:
            return {
                ...state,
                showCardholderPage: false,
                showVisitorPassPage: true,
                showJobRoleSelectionPage: false,
                currentQrCode: action.qrCode,
                cardholderPageContext: action.context,
            };
        case cardConstants.HIDE_VISITOR_PASS_PAGE:
            return {
                ...state,
                cardholderPageContext: '',
                showCardholderPage: false,
                showVisitorPassPage: false,
                showJobRoleSelectionPage: false,
                currentQrCode: null
            };
        case cardConstants.GET_CARD_DATA_SUCCESS:
            return {
                ...state,
                cards: {
                    ...appendCard(state.cards || {}, action.data)
                }
            };
        case cardConstants.GET_VISITOR_PASS_SUCCESS:
            return {
                ...state,
                passes: {
                    ...appendPass(state.passes || {}, action.data)
                }
            }
        default:
            return state;
    }
}